import React from 'react';
import { coverage, braidingImage } from '../data/content';
export function Coverage() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="coverage-heading" data-id="element-64" data-mp="4nxhefwo5l6d">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-65" data-mp="ifc3wwpsc4i6">
        <img src={braidingImage} alt="A stylist braiding clean cornrows into a client's hair" className="aspect-[4/5] w-full rounded-2xl object-cover shadow-card" loading="lazy" data-id="element-66" data-mp="dnu0m20ahru1" />
        <div data-id="element-67" data-mp="nddlfd7kbvrj">
          <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-68" data-mp="ndlvyyg7qozk">
            Total coverage
          </p>
          <h2 id="coverage-heading" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-espresso sm:text-4xl" data-id="element-69" data-mp="wetlar0r4fhi">
            Absolute beginner through paid professional
          </h2>
          <ul className="mt-8 divide-y divide-espresso/10 border-y border-espresso/10" data-id="element-70" data-mp="2y7htles95t45">
            {coverage.map(item => <li key={item.number} className="flex items-center gap-5 py-4" data-id="element-71" data-mp="3i3f5wy8f9b1e">
                <span className="font-display text-sm font-bold text-gold" data-id="element-72" data-mp="3n4mbqrr0805f">
                  {item.number}
                </span>
                <span className="font-sans text-lg font-semibold text-espresso" data-id="element-73" data-mp="orvx1w23pb0">
                  {item.label}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}